import { rangeColors } from "./helpers";

const RangeQuestionRubric = () => (
  <div className="flex items-center gap-2">
    <div className="text-xs">Low</div>
    {rangeColors.map((color) => (
      <div
        key={color}
        className="h-3 w-3 rounded-sm"
        style={{ backgroundColor: color }}
      />
    ))}
    <div className="text-xs">High</div>
  </div>
);

export default RangeQuestionRubric;
